import React, { useEffect, useState, useCallback } from 'react';
import { api } from '../../api';
import { Trash2, Mail, Phone, Calendar as Cal, Tag } from 'lucide-react';

const BookingsAdmin = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get('/admin/bookings');
      setItems(r.data || []);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const del = async (id) => {
    if (!window.confirm('Supprimer cette demande ?')) return;
    await api.delete(`/admin/bookings/${id}`);
    await load();
  };

  let body;
  if (loading) {
    body = <div className="text-center text-[#8A8275] py-12">Chargement…</div>;
  } else if (items.length === 0) {
    body = (
      <div className="text-center py-16 border border-dashed border-[#E8E2D5] bg-[#FAF8F4]">
        <div className="display text-[20px] text-[#957340]">Aucune demande pour l’instant.</div>
        <p className="text-[12px] text-[#8A8275] mt-2">Les nouvelles demandes apparaîtront ici automatiquement.</p>
      </div>
    );
  } else {
    body = (
      <div className="space-y-4">
        {items.map((b) => (
          <div key={b.id} className="bg-white border border-[#E8E2D5] p-5">
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mb-3">
                  <span className="serif text-[18px] font-medium">{b.name}</span>
                  {b.service && <span className="text-[10px] tracking-[0.28em] uppercase border border-[#957340] text-[#957340] px-2 py-0.5"><Tag size={10} className="inline mr-1" />{b.service}</span>}
                  <span className="text-[11px] text-[#8A8275]"><Cal size={11} className="inline mr-1" />{new Date(b.at).toLocaleString('fr-FR')}</span>
                </div>
                <div className="grid sm:grid-cols-2 gap-2 text-[13px] text-[#3A3A3A]">
                  <a href={`mailto:${b.email}`} className="flex items-center gap-2 hover:text-[#957340]"><Mail size={13} /> {b.email}</a>
                  {b.phone && <a href={`tel:${b.phone}`} className="flex items-center gap-2 hover:text-[#957340]"><Phone size={13} /> {b.phone}</a>}
                </div>
                {b.message && <p className="mt-3 text-[14px] text-[#1A1A1A] bg-[#FAF8F4] border-l-2 border-[#957340] p-3 leading-relaxed">{b.message}</p>}
              </div>
              <button onClick={() => del(b.id)} className="p-2 text-[#8A8275] hover:text-red-600"><Trash2 size={15} /></button>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div>
      <div className="mb-8">
        <h2 className="h-display text-[32px]">Demandes de réservation</h2>
        <p className="text-[13px] text-[#8A8275] mt-1">{items.length} demande{items.length > 1 ? 's' : ''} reçue{items.length > 1 ? 's' : ''}.</p>
      </div>
      {body}
    </div>
  );
};

export default BookingsAdmin;
